import { useState, useEffect } from "react";
import {
  Frame,
  Loading,
  Header,
  VerContrato,
  Print,
  ValidaUid,
} from "../components";
import { useNavigate } from "react-router-dom";
import { db, auth } from "../config/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import moment from "moment";
import { Col, Row } from "react-bootstrap";

const Aceite = () => {
  const [dados, setDados] = useState({});
  const [loading, setLoading] = useState(true);

  let uid = auth.currentUser?.uid;

  const navigate = useNavigate();

  const setData = async () => {
    await setDoc(
      doc(db, "furg2026", uid),
      { status: "p", contrato: "2026", aceite: moment().format() },
      { merge: true },
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    setData().then(() => navigate("../home"));
  };

  const buscaDados = async () => {
    const uid = await ValidaUid();

    if (uid) {
      const qry = await getDoc(doc(db, "furg2026", uid));

      const data = qry.data();

      const contrato = data?.contrato;

      if (contrato !== "2026") {
        setDados(data);
        setLoading(false);
      } else navigate("../home");
    }
  };

  useEffect(() => {
    buscaDados();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading && <Loading />}
      <Header />
      {!loading && (
        <Frame
          body={
            <form autoComplete="off" onSubmit={handleSubmit} noValidate>
              <VerContrato dados={dados} />
              <Print />
              <Row className="mt-3">
                <Col className="d-grid">
                  <button type="submit" className="btn btn-primary">
                    LI E CONCORDO COM OS TERMOS DO SERVIÇO
                  </button>
                </Col>
              </Row>
            </form>
          }
        />
      )}
    </>
  );
};

export default Aceite;
